export default {
  user: JSON.parse(localStorage.getItem('user')) || {},
  get token() {
    return localStorage.getItem('token');
  },
  set token(value) {
    return localStorage.setItem('token', value);
  },
  elevatorList: [], //电梯列表
  motorEchartData: null, //电机图表数据
  speedEchartData: null, //运行速度图表数据
  mileageEchartData: null, //运行里程图表数据
  angleEchartData: null, //电梯倾角图表数据
  perEchartData: null,//运行次数图表数据
  warningList: [], //异常列表
  realTimeData: null, //实时状态的数据
  curElevator:null,
  // curElevatorId: null, //当前选中的电梯Id
  curElevatorType: 'elevator',//电梯类型
  curSensorList: [], //当前传感器列表
  sensorClassificationList: [], //分类后的传感器列表
  motorTimeRange: localStorage.getItem("motorTimeRange") || "1h",
  motorTimeRange2: localStorage.getItem("motorTimeRange2") || "1h",
  speedTimeRange: localStorage.getItem("speedTimeRange") || "1h",
  angleTimeRange: localStorage.getItem("angleTimeRange") || "1h",
  distanceTimeRange: localStorage.getItem("distanceTimeRange") || "1w",
  escalatorTimeRange: localStorage.getItem("escalatorTimeRange") || "1h",
  escalatorTimeRange2: localStorage.getItem("escalatorTimeRange2") || "1h",
  localtionData:[114.935486, 22.688432],
  mapzoom:16,
  siteList:[],//站点列表
  customerList:[],
  loading: false, //屏幕加载
  curElevatorId:[],//设备列表选中的电梯id
  curEdgeId:'',//设备列表选中的边缘终端id
  timeRange: 1, //图表默认时间范围(小时),
  curElevatorName:'',//设备列表选中的电梯Name
  curEdgeuuid:'',//设备列表选中的终端uuid
  cursite:'',
  curElevatorInfo:[],
  curVibrationSensorList: [], //在音频分析中的直梯传感器列表
  curEscalatorSensorList: [], //在音频分析中的扶梯传感器列表
  curEscalatorSensorList2: [],
  role: sessionStorage.getItem("role") ,
  curAudioData: null,
}



// WEBPACK FOOTER //
// ./src/store/state.js